export const mealConfigRoutes = [
  {
    path: '/meal-group',
    component: () => import('@/views/mealConfig/MealGroup.vue'),
    name: 'meal-group',
    meta: { title: 'Nhóm đăng ký ăn', auth: true }
  },
  {
    path: '/meal-group-detail/:id',
    component: () => import('@/views/mealConfig/DetailMealGroup.vue'),
    name: 'meal-group-detail',
    meta: { title: 'Chi tiết nhóm đăng ký ăn', auth: true }
  },
  {
    path: '/fixed-meals',
    component: () => import('@/views/mealConfig/MealSlot.vue'),
    name: 'fixed-meals',
    meta: { title: 'Bữa ăn cố định', auth: true }
  },
  {
    path: '/supplementary-meals',
    component: () => import('@/views/mealConfig/MealSlot.vue'),
    name: 'supplementary-meals',
    meta: { title: 'Bữa ăn bổ sung', auth: true }
  },
  {
    path: '/meal-slots/:id',
    component: () => import('@/views/mealConfig/MealSlotDetail.vue'),
    name: 'meal-slot-detail',
    meta: { title: 'Chi tiết bữa ăn', auth: true }
  },
  {
    path: '/meal-locks',
    component: () => import('@/views/mealConfig/MealLock.vue'),
    name: 'meal-locks',
    meta: { title: 'Khóa đăng ký ăn', auth: true }
  },
  {
    path: '/meal-lock-detail/:id',
    component: () => import('@/views/mealConfig/MealLockDetail.vue'),
    name: 'meal-lock-detail',
    meta: { title: 'Chi tiết khóa đăng ký', auth: true }
  }
]
